export enum FlowType{
    UPDATE_ACCOUNTS_IN_SALESFORCE = "UPDATE_ACCOUNTS_IN_SALESFORCE",
    UPDATE_CONTACTS_IN_SALESFORCE = "UPDATE_CONTACTS_IN_SALESFORCE",
    UPDATE_DATA_FROM_IQVIA = "UPDATE_DATA_FROM_IQVIA",
}